// Use the singleton from supabaseClient.js
import { getSupabase } from '../supabaseClient';

// Re-export for compatibility
export const supabase = getSupabase();